import { render, staticRenderFns } from "./AbschnittErstgespraech.vue?vue&type=template&id=4c42bb44&"
import script from "./AbschnittErstgespraech.vue?vue&type=script&lang=js&"
export * from "./AbschnittErstgespraech.vue?vue&type=script&lang=js&"
import style0 from "./AbschnittErstgespraech.vue?vue&type=style&index=0&id=4c42bb44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports